import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class NewclientsService {
    private _newclientsServiceReportUrl = CONFIGURATION.baseServiceUrl + 'new-client/';
    constructor(private _http: Http) { }

    getReferenceData(): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._newclientsServiceReportUrl + 'reference-data', { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getReportData(data:any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._newclientsServiceReportUrl + 'report-data', data, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    getShowsReportData(data:any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._newclientsServiceReportUrl + 'shows-report-data', data, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getGrossReportData(data:any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._newclientsServiceReportUrl + 'gross-ytd-report-data', data, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    downloadExcelReport(filterCriteria: any): any {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._newclientsServiceReportUrl + 'excel-download', filterCriteria, { headers: headers, responseType: ResponseContentType.Blob }).map(
            (res) => {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const blob = new Blob([res.blob()], { type: 'application/zip' });
                const downloadUrl = URL.createObjectURL(blob);
                window.open(downloadUrl);
            })
    }
  
    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
    }
}



// WEBPACK FOOTER //
// ./src/app/newclients/newclients.service.ts